// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgMenuReferredPatient = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#menu_referred_patient_svg__a)">
      <path
        fill={props.color ?? 'currentColor'}
        d="M13.888 10.545v-.018l-.136-.426-1.264-4.026V6.05c-.024-.052-.064-.078-.112-.078h-.016c-.392-.061-.832-.183-1.256-.296-.816-.226-1.584-.443-2.16-.27-.36.105-1.728.766-2.072 1.653l-.728 1.739v.017c-.04.13-.04.279.016.4a.45.45 0 0 0 .24.253c.272.104.792.174 1.224-.487.2-.34.352-.635.44-.81.032-.06.056-.112.072-.138 0-.009.016-.018.024-.018l.608-.06a.2.2 0 0 1 .128.043c1.384 1.096 2.152 1.817 3.504 3.009q.05.04.112.026h.032c.008 0 .016 0 .032-.009h.024c.352-.113.984-.27 1.176-.278h.048v-.087zM2.84 5.319a.48.48 0 0 0-.232-.261l-.8-.366s-.056-.008-.08 0a.15.15 0 0 0-.056.07L0 9.98s-.008.07 0 .095c.008.035.032.053.056.07l.8.365c.048.018.096.035.144.035a.4.4 0 0 0 .168-.044.44.44 0 0 0 .216-.278l1.44-4.53a.6.6 0 0 0-.008-.374zM14.336 4.719s-.032-.061-.056-.07a.07.07 0 0 0-.08 0l-.8.365a.45.45 0 0 0-.232.261.55.55 0 0 0-.008.374l1.44 4.53c.04.122.12.218.216.279a.4.4 0 0 0 .168.043.3.3 0 0 0 .144-.034l.8-.366s.048-.034.056-.07c.008-.034.016-.069 0-.095l-1.656-5.209zM12.112 11.258c-.272-.2-.648-.122-.832.183l-.672 1.087a.62.62 0 0 1-.424.295l-.496.087a.65.65 0 0 0-.464.687c.032.34.296.591.608.583h.096l.4-.052c.024 0 .048-.018.072-.018l.128-.017s.024-.018.032-.018c.416-.121.792-.4 1.04-.8l.672-1.087a.684.684 0 0 0-.168-.904zM2.784 11.615l-.392-.261a.67.67 0 0 1-.256-.765L3.552 5.97c.096-.304.384-.496.672-.435l.632.122c.136.026.272 0 .392-.07l.688-.417c.288-.174.656-.061.816.252s.056.713-.232.887l-.936.565c-.2.122-.432.157-.656.122l-.4-.078-1.104 3.591.392.261c.072.052.096.087.024.2l-.232.426a.58.58 0 0 1-.824.226zM8.568 12.267c-.288-.174-.632-.105-.76.148.128-.253 0-.6-.296-.774s-.632-.105-.76.147c.128-.252 0-.6-.296-.774-.296-.173-.632-.104-.76.148.128-.252 0-.6-.296-.774s-.632-.104-.76.148l-.232.461-.08.157-.08.156-.08.157-.232.46c-.128.253 0 .6.296.774s.632.105.76-.147c-.128.252 0 .6.296.774s.632.104.76-.148c-.128.252 0 .6.296.774s.632.104.76-.148c-.128.252 0 .6.296.774s.632.104.76-.148l.232-.46.08-.157.08-.157.08-.156.232-.461c.128-.252 0-.6-.296-.774"
      />
      <path
        stroke={props.color ?? 'currentColor'}
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M8 1.688v1.6M10.808 2.128l-.552 1.504M5.2 2.104l.544 1.504"
      />
    </g>
    <defs>
      <clipPath id="menu_referred_patient_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgMenuReferredPatient
